import React from 'react';
import PropTypes from 'prop-types';
import style from './styles.scss';

const FinalSegments = ({
  executed,
  liveSets,
  typologySets,
  setTypologySets
}) => {
  if (!liveSets?.data) {
    return <></>;
  }

  const handleAction = (typologyId, combinationId) => {
    setTypologySets((prev) =>
      prev?.map((p) => {
        if (p.typologyId === typologyId) {
          return {
            ...p,
            segmentCombinationIds: combinationId
              ? p.segmentCombinationIds.filter((f) => f !== combinationId)
              : p.segmentCombinationIds,
            useDefault: !combinationId ? false : p.useDefault
          };
        } else {
          return p;
        }
      })
    );
  };

  return (
    <div className={style.selectedSetsPanel}>
      <div className={style.setsPanelText}>
        <p>
          Final Segment to typology mapping (Based on the configurations made)
        </p>
      </div>
      {liveSets?.data?.combinations?.map((combinations) => {
        if (
          typologySets.some((t) =>
            t.segmentCombinationIds.includes(combinations.id)
          )
        ) {
          return (
            <table className={style.displayTable} key={combinations.id}>
              <thead>
                <tr className={style.rowDisplay}>
                  <th className={style.tableHeader}>
                    {combinations.entries
                      ?.map((entries) => entries.value)
                      .toString()}
                  </th>
                  <th className={style.tableHeader}>Action</th>
                </tr>
              </thead>
              <tbody>
                {typologySets?.map((typology) => {
                  if (
                    typology.segmentCombinationIds.includes(combinations.id)
                  ) {
                    return (
                      <tr
                        className={style.rowDisplay}
                        key={typology.typologyId}>
                        <td className={style.tableData}>
                          {typology.typologyName}
                        </td>
                        <td
                          className={style.tableData}
                          key={typology.typologyId}
                          style={{ padding: 0 }}>
                          <button
                            disabled={executed}
                            onClick={() =>
                              handleAction(typology.typologyId, combinations.id)
                            }
                            style={{ color: '#0C8ED7' }}>
                            {' '}
                            Remove
                          </button>
                        </td>
                      </tr>
                    );
                  }
                  return null;
                })}
              </tbody>
            </table>
          );
        }
      })}
      {typologySets.some((t) => t.useDefault) && (
        <table className={style.displayTable}>
          <thead>
            <tr className={style.rowDisplay}>
              <th className={style.tableHeader}>{`Default`}</th>
              <th className={style.tableHeader}>Action</th>
            </tr>
          </thead>
          <tbody>
            {typologySets?.map((typology) => {
              if (typology.useDefault) {
                return (
                  <tr className={style.rowDisplay} key={typology.typologyId}>
                    <td className={style.tableData}>{typology.typologyName}</td>
                    <td
                      className={style.tableData}
                      key={typology.typologyId}
                      style={{ padding: 0 }}>
                      <button
                        disabled={executed}
                        onClick={() => handleAction(typology.typologyId)}
                        style={{ color: '#0C8ED7' }}>
                        {' '}
                        Remove
                      </button>
                    </td>
                  </tr>
                );
              }
              return null;
            })}
          </tbody>
        </table>
      )}
    </div>
  );
};

FinalSegments.propTypes = {
  liveSets: PropTypes.object,
  typologySets: PropTypes.array,
  setTypologySets: PropTypes.func,
  executed: PropTypes.bool
};

export default FinalSegments;
